<template>
  <Teleport to="body">
    <Transition name="modal">
      <div
        v-if="show"
        class="fixed inset-0 z-50 flex items-center justify-center p-4"
        @keydown.esc="!persistent && $emit('close')"
        tabindex="-1"
      >
        <div
          class="absolute inset-0 bg-black/70 backdrop-blur-sm"
          @click="!persistent && $emit('close')"
        ></div>
        <div
          :class="[
            'relative bg-bg-1 border border-line rounded-[var(--radius-lg)] shadow-2xl',
            'w-full flex flex-col max-h-[90vh] overflow-hidden',
            sizeClass,
          ]"
        >
          <header class="flex items-center justify-between px-5 py-3 border-b border-line shrink-0">
            <div class="min-w-0">
              <h3 class="text-sm font-semibold text-text truncate">{{ title }}</h3>
              <p v-if="subtitle" class="font-mono text-[11px] text-text-3 truncate mt-0.5">
                {{ subtitle }}
              </p>
            </div>
            <button
              v-if="!persistent"
              type="button"
              @click="$emit('close')"
              class="text-text-3 hover:text-text p-1 rounded hover:bg-bg-2"
              aria-label="Close"
            >
              <X :size="16" />
            </button>
          </header>
          <div class="flex-1 overflow-y-auto px-5 py-4">
            <slot />
          </div>
          <footer
            v-if="$slots.footer"
            class="flex items-center justify-end gap-2 px-5 py-3 border-t border-line shrink-0"
          >
            <slot name="footer" />
          </footer>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue';
import { X } from 'lucide-vue-next';

const props = defineProps({
  show:       { type: Boolean, required: true },
  title:      { type: String, required: true },
  subtitle:   { type: String, default: '' },
  size:       { type: String, default: 'md' }, // sm | md | lg | xl
  persistent: { type: Boolean, default: false },
});
defineEmits(['close']);

const sizeClass = computed(() => ({
  sm: 'max-w-sm',
  md: 'max-w-lg',
  lg: 'max-w-2xl',
  xl: 'max-w-4xl',
}[props.size]));
</script>

<style scoped>
.modal-enter-active, .modal-leave-active { transition: opacity var(--dur) var(--ease); }
.modal-enter-from, .modal-leave-to { opacity: 0; }
</style>
